import React from 'react';
import * as LucideIcons from 'lucide-react';

// Colorful gradient icon wrapper
const ColorfulIcon = ({ icon, size = 24, gradient = 'blue', className = '' }) => {
  const Icon = LucideIcons[icon];
  
  if (!Icon) return null;

  const gradients = {
    blue: 'from-blue-500 to-cyan-500',
    purple: 'from-purple-500 to-pink-500',
    green: 'from-green-500 to-emerald-500',
    orange: 'from-orange-500 to-red-500',
    teal: 'from-teal-500 to-blue-500',
    indigo: 'from-indigo-500 to-purple-500',
    rose: 'from-rose-500 to-pink-500',
    amber: 'from-amber-500 to-orange-500',
  };

  return (
    <div className={`relative inline-flex ${className}`}>
      <div className={`absolute inset-0 bg-gradient-to-br ${gradients[gradient]} opacity-20 blur-xl rounded-full`}></div>
      <div className={`relative p-3 bg-gradient-to-br ${gradients[gradient]} rounded-xl shadow-lg`}>
        <Icon size={size} className="text-white" strokeWidth={2} />
      </div>
    </div>
  );
};

export default ColorfulIcon;